import { createContext } from 'react'

import {
  HouseOwnerLightContextFieldFragment,
  LoginMutationVariables,
} from '@/lib/graphql'

export interface AuthContextInterface {
  user: HouseOwnerLightContextFieldFragment | null
  isAuthenticated: boolean
  isLoadingAuthentication: boolean
  runLogin: (params: LoginMutationVariables) => Promise<void>
  runLogout: () => Promise<void>
  dispatchLogin: (user: HouseOwnerLightContextFieldFragment) => void
}

export const AuthContext = createContext({} as AuthContextInterface)
